import { useEffect, useMemo, useState } from 'react';
import MapaBase from './MapaBase';
import { ListarPuntosControlResumen } from '../../../services/api';
import { useAuth } from '../../../context/AuthContext';
import { peTime } from '../../../util/util';
import { minutesDiff, minutesDiffDisplay } from '../../../helper/dateHelper';

export default function PuntosControlPorRonda({ round, assignment, pointControls }) {
    const { token } = useAuth();
    const [aryPTStatus, setAryPTStatus] = useState([]);
    const leerServicios = async () => {
        if (!round?.id) {
            setAryPTStatus([]);
            return;
        }

        try {
            const data = await ListarPuntosControlResumen({ roundId: round.id, token });
            console.log(data)
            setAryPTStatus(Array.isArray(data) ? data.sort((a, b) => a.order - b.order) : []);
        } catch (err) {
            console.error(err);
            setAryPTStatus([]);
        }
    };

    useEffect(() => {
        leerServicios();
    }, [round?.id, token]);

    const pointControlMap = useMemo(() => {
        if (!Array.isArray(pointControls)) return new Map();
        return new Map(pointControls.map(pc => [pc.id, pc]));
    }, [pointControls]);

    // const estadoLabel = (derivedState) => (derivedState === 2 ? 'Llego' : 'Pendiente');
    const estadoPuntoControl = (estado) => {
        switch (estado) {
            case 0:
                return 'Pendiente';
            case 1:
                return 'Llego';
            case 2:
                return 'Completado';
            default:
                return 'Desconocido';
        }
    }
    return (
        <>
            <h1>Puntos de Control</h1>
            <div className="row">
                <div className="col-12">
                    <MapaBase round={round} assignment={assignment} pointControls={pointControls} />
                </div>
                <div className="col-12">
                    <div className="card shadow-sm h-100">
                        <div className="card-header bg-white">
                            <h5 className="mb-0">Resumen</h5>
                        </div>
                        <div className="card-body p-0">
                            {aryPTStatus.length === 0 ? (
                                <div className="text-center text-muted py-5">Sin puntos de control</div>
                            ) : (
                                <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <table className="table table-sm table-hover mb-0">
                                        <thead className="table-light position-sticky top-0" style={{ zIndex: 1 }}>
                                            <tr className='text-center'>
                                                <th style={{ width: '10%' }}>Orden  </th>
                                                <th style={{ width: '30%' }}>Punto</th>
                                                <th style={{ width: '20%' }}>Hora</th>
                                                <th style={{ width: '10%' }}>Tiempo (Minutos)</th>
                                                <th style={{ width: '25%' }}>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody className='text-center'>
                                            {aryPTStatus.map((pt) => {
                                                const punto = pointControlMap.get(pt.pointControlId);
                                                console.log(pt)
                                                return (
                                                    <tr key={pt.pointControlId}>
                                                        <td>{pt.order}</td>
                                                        <td>
                                                            <div>{punto?.name ?? 'Sin nombre'}</div>

                                                        </td>
                                                        <td><small>{pt.initDatePlanning === null ? '' : peTime(pt.initDatePlanning)} - {pt.endDatePlanning === null ? '' : peTime(pt.endDatePlanning)}</small></td>
                                                        <td><small>{minutesDiffDisplay(pt.initDatePlanning, pt.endDatePlanning)}</small></td>
                                                        <td>{estadoPuntoControl(pt.derivedState)}</td>
                                                        {/* export type DerivedState = 0 | 1 | 2; // 0 pendiente, 1 llegó, 2 completado */}

                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

